import { useCallback, useState } from "react";
import ConfirmDialog from "./ConfirmDialog";

// Drop-in replacement for window.confirm that renders the branded dialog.
//   const [confirm, confirmDialog] = useConfirm();
//   if (!(await confirm({ title: "Delete file", description: "..." }))) return;
//   ...render {confirmDialog} once in the component.
export default function useConfirm() {
  const [state, setState] = useState(null);

  const confirm = useCallback(
    (options) => new Promise((resolve) => setState({ options, resolve })),
    []
  );

  const close = useCallback((result) => {
    setState((prev) => {
      prev?.resolve(result);
      return null;
    });
  }, []);

  const element = (
    <ConfirmDialog
      open={Boolean(state)}
      {...(state?.options || {})}
      onConfirm={() => close(true)}
      onClose={() => close(false)}
    />
  );

  return [confirm, element];
}
